import { render } from "./BoardViewMenu.vue?vue&type=template&id=21c59f7c"
import script from "./BoardViewMenu.vue?vue&type=script&lang=js"
export * from "./BoardViewMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__